import { create } from 'zustand';
export const useUserStore = create((set) => ({
    location: null,
    isTrackingLocation: false,
    defaultLocation: [60.171006, 24.934051],
    setLocation: (location) => set({ location }),
    setTrackingLocation: (isTracking) => set({ isTrackingLocation: isTracking }),
    resetLocation: () => set({ location: null, isTrackingLocation: false }),
}));
